import {
  createRouter,
  createWebHistory,
  createWebHashHistory,
} from "vue-router";
import HomeView from "../views/HomeView.vue";
import HomeView2 from "../views/HomeView2.vue";
// import HomeView from "../views/home.vue";
// import about from "../views/about.vue";
// import detail from "../views/detail.vue";
// import HomeView from "../views/HomeView.vue";

import SucaiDetail from "@/views/SucaiDetail.vue";
const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
    meta: { keepAlive: true },
  },
  {
    path: "/home2",
    name: "home2",
    component: HomeView2,
    meta: {},
  },
  // {
  //   path: "/detail",
  //   name: "detail",
  //   component: detail,
  //   meta: {},
  // },
  // {
  //   path: "/about",
  //   name: "about",
  //   meta: {},
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import("../views/AboutView.vue"),
  // },

  { path: "/sucaiDetail", component: SucaiDetail },
];

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
});

export default router;
